import { Alert } from '@mui/material';
import styled from 'styled-components';

interface IErrorProps {
  show: boolean;
}

const StyledAlert = styled(Alert)`
  max-width: 280px;
  border-radius: 20px !important;
  font-size: 0.8rem !important;
`;

const ShowError = styled.div<IErrorProps>`
  visibility: ${props => (!props.show ? 'hidden' : '')};
  opacity: ${props => (!props.show ? 0 : 1)};
  transition: visibility 0s, opacity 0.5s linear;
`;

export { StyledAlert, ShowError };
